import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { FeatureFlagService } from "@app/services/feature-flag.service";
import { FeatureFlagKey } from "@app/services/feature-flag.models";

/**
 * Gates a route (or route subtree) on a feature flag (FLIP-304). Configure via the route's
 * `data.featureFlag`, e.g. `{ path: 'onboarding-preview', canActivate: [FeatureFlagGuard], data: { featureFlag: FeatureFlagKeys.OnboardingWalkthrough } }`.
 *
 * Redirects to Home rather than blocking with no destination, matching how OnboardingGuard
 * redirects to /onboarding rather than just returning false.
 */
@Injectable()
export class FeatureFlagGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private featureFlagService: FeatureFlagService) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const key = route.data?.featureFlag as FeatureFlagKey | undefined;
    if (!key || this.featureFlagService.isEnabled(key)) {
      return true;
    }

    this.router.navigate(["/landing-page"]);
    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }
}
